import { useSelector } from "react-redux";
import { ApplicationState } from "..";

export const useAnnouncementReducer = () => useSelector((state: ApplicationState) => state.announcement);
